export enum PostQualityIndicatorType {
  WELL_WRITTEN = "wellWritten",
  HELPFUL_EXPLANATION = "helpfulExplanation",
  INSIGHTFUL = "insightful",
  RESPECTFUL_TONE = "respectfulTone",
  CONCISE = "concise",
  ENGAGING = "engaging",
  SUPPORTIVE = "supportive"
}

export interface PostQualitySummary {
  count: number;
  averageScore: number;
}

export interface RecentPostQualityIndicator {
  badgeType: PostQualityIndicatorType;
  postId: number;
  score: number;
  achievedAt: string;
}

export interface UserPostQualityResponse {
  userId: number;
  period: number;
  manyThreshold: number;
  badgeSummary: {
    [key in PostQualityIndicatorType]?: PostQualitySummary;
  };
  totalBadgesEarned: number;
  recentBadges: RecentPostQualityIndicator[];
}

export const POST_QUALITY_INDICATOR_COLORS: { [key in PostQualityIndicatorType]: string } = {
  [PostQualityIndicatorType.WELL_WRITTEN]: "#6b9bd1",
  [PostQualityIndicatorType.HELPFUL_EXPLANATION]: "#7fb069",
  [PostQualityIndicatorType.INSIGHTFUL]: "#9b7fb8",
  [PostQualityIndicatorType.RESPECTFUL_TONE]: "#6fa8b5",
  [PostQualityIndicatorType.CONCISE]: "#c99c5f",
  [PostQualityIndicatorType.ENGAGING]: "#c77b8f",
  [PostQualityIndicatorType.SUPPORTIVE]: "#b8a063"
};

export const POST_QUALITY_INDICATOR_LABELS: { [key in PostQualityIndicatorType]: string } = {
  [PostQualityIndicatorType.WELL_WRITTEN]: "Well written",
  [PostQualityIndicatorType.HELPFUL_EXPLANATION]: "Helpful",
  [PostQualityIndicatorType.INSIGHTFUL]: "Insightful",
  [PostQualityIndicatorType.RESPECTFUL_TONE]: "Respectful",
  [PostQualityIndicatorType.CONCISE]: "Concise",
  [PostQualityIndicatorType.ENGAGING]: "Engaging",
  [PostQualityIndicatorType.SUPPORTIVE]: "Supportive"
};

export const POST_QUALITY_INDICATOR_ICONS: { [key in PostQualityIndicatorType]: string } = {
  [PostQualityIndicatorType.WELL_WRITTEN]: "pen",
  [PostQualityIndicatorType.HELPFUL_EXPLANATION]: "handshake",
  [PostQualityIndicatorType.INSIGHTFUL]: "lightbulb",
  [PostQualityIndicatorType.RESPECTFUL_TONE]: "user-group",
  [PostQualityIndicatorType.CONCISE]: "compress",
  [PostQualityIndicatorType.ENGAGING]: "comments",
  [PostQualityIndicatorType.SUPPORTIVE]: "heart"
};
